import { useMutation, useQueryClient } from '@tanstack/react-query'

import { RequestsService } from '../lib/requests.service'
import { REQUESTS_LIST_RQ_KEY } from './useRequestsList'

export const useDeleteRequest = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (requestId: string) => RequestsService.deleteRequest(requestId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [REQUESTS_LIST_RQ_KEY]
      })
    }
  })
}
